import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { useClient } from '../../../hooks/useClient';
import useScreenSize from '../../../hooks/useScreenSize';
import { Button } from '../../ui/Button';
import { ItemConnectionSort } from '../../../graphql/types';
import { SortingFilterPlaceholder } from '../../../styled/placeholders.styled';

const SortingFilter = dynamic(
  () =>
    import('../../NewSearch/NewSearchBar/SortingFilter').then(
      mod => mod.SortingFilter
    ),
  { ssr: false, loading: SortingFilterPlaceholder }
);

export const FilterButtons: React.FC<{
  showValueInInput?: boolean;
  showIcon?: boolean;
  initialSort?: ItemConnectionSort;
  setFilterValues: (filters: unknown) => void;
  defaultCategoryId: string;
}> = ({
  setFilterValues,
  showValueInInput = true,
  showIcon = true,
  initialSort,
  defaultCategoryId
}) => {
  const isClient = useClient();
  const { isSmall, isTablet } = useScreenSize();
  const { t } = useTranslation();
  const router = useRouter();

  const onReset = useCallback(() => {
    const defaultFilters = {
      areaFrom: undefined,
      areaTo: undefined,
      buildingType: undefined,
      categoryId: defaultCategoryId,
      cityId: undefined,
      floorFirst: undefined,
      floorFrom: undefined,
      floorLast: undefined,
      floorTo: undefined,
      hasBillOfSale: undefined,
      hasMortgage: undefined,
      hasRepair: undefined,
      landAreaFrom: undefined,
      landAreaTo: undefined,
      leased: false,
      locationIds: undefined,
      onlyResidences: undefined,
      paidDaily: undefined,
      priceFrom: undefined,
      priceTo: undefined,
      roomIds: undefined
    };

    setFilterValues(defaultFilters);
    router.replace({ pathname: router.pathname }, '/pasha', {
      shallow: true
    });
  }, [setFilterValues, defaultCategoryId, router]);

  return (
    <>
      <Button
        type="button"
        cypress="pasha-landing-reset-button"
        stat="pasha-landing-reset-button"
        text={t('common.reset')}
        onClick={onReset}
        styles={
          (isSmall || isTablet) && isClient
            ? `width: calc(100% - 62px);`
            : `max-width: 226px; width: 226px;`
        }
        background="#0f1629"
        hover="background: #1a2b47;"
      />
      <SortingFilter
        submitOnChange
        showIcon={showIcon}
        initialSort={initialSort}
        isPashaLanding
      />
    </>
  );
};
